import { RepositoryFactory } from '../../RepositoryFactory';
const users = new RepositoryFactory('users');

export default {
  namespaced: true,
  state: {
    // Single user
    user: {
      id: null,
      name: '',
      email: '',
    },
    users: [],

    // Pagination Params
    currentPage: 1,
    total: 0,
    totalPages: 0,
    itemCount: 0,

    // Actions States
    loading: false,
    error: false,
  },
  getters: {
    getUser(state) {
      return state.user;
    },
    getUsers(state) {
      return state.users;
    },
    getUsersTableData(state) {
      return {
        error: state.error,
        loading: state.loading,
        currentPage: state.currentPage,
        totalPages: state.totalPages,
        itemCount: state.itemCount,
        total: state.total,
      };
    },
  },
  mutations: {
    SET_USER(state, data) {
      state.user = data;
    },
    SET_USERS(state, data) {
      state.users = data.items;
      state.total = data.totalOfItems;
      // state.itemCount = data.pageCount;
      state.totalPages = data.pageCount;
    },
    SET_PAGE(state, page) {
      state.currentPage = page;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_ERROR(state, error) {
      state.error = error;
    },
  },
  actions: {
    setPage: async ({ commit, dispatch }, page) => {
      commit('SET_PAGE', page);
      dispatch('getUsers');
    },
    resetPagination: async ({ commit, dispatch }) => {
      commit('SET_PAGE', 1);
      dispatch('getUsers');
    },
    getUserById: async ({ commit }, id) => {
      try {
        const { data } = await users.getById(id);
        commit('SET_USER', data);
      } catch (error) {}
    },
    getUsers: async ({ state, commit }) => {
      commit('SET_ERROR', null);
      commit('SET_LOADING', true);
      try {
        const { data } = await users.get(state.currentPage);
        commit('SET_USERS', data);
      } catch (error) {
        commit('SET_ERROR', error);
      }
      commit('SET_LOADING', false);
    },
  },
};
